/** The line icons of the new shell (24 × 24, stroke) — the paths of the canvas boards Shell*. */
export const SHELL_ICON = {
  cake: 'M3 21h18M5 21v-7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7M5 16.5c1.5 1 3 1 4.5 0s3-1 4.5 0 3 1 4.5 0M8 12V9M12 12V9M16 12V9M8 5.5v.01M12 5.5v.01M16 5.5v.01',
  search: 'M11 4a7 7 0 1 0 0 14a7 7 0 0 0 0-14zM20 20l-4-4',
  phone: 'M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2',
  bell: 'M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9M10 21h4',
  sun: 'M12 3v1.5M12 19.5V21M3 12h1.5M19.5 12H21M5.6 5.6l1.1 1.1M17.3 17.3l1.1 1.1M5.6 18.4l1.1-1.1M17.3 6.7l1.1-1.1M8 12a4 4 0 1 0 8 0a4 4 0 1 0-8 0',
  moon: 'M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z',
  auto: 'M3 5h18v11H3zM8 20h8M12 16v4',
  check: 'M5 12l5 5 9-10',
  checks: 'M2.5 12.5l4.5 4.5 9.5-9.5M11.5 16.5l.5.5 9.5-9.5',
  warn: 'M12 4l9 16H3zM12 10v4M12 17h.01',
  alert: 'M12 7v6M12 17h.01',
  close: 'M6 6l12 12M18 6L6 18',
  down: 'M6 9l6 6 6-6',
  right: 'M9 6l6 6-6 6',
  flask: 'M9 3h6M10 3v6L5 19a1 1 0 0 0 1 2h12a1 1 0 0 0 1-2l-5-10V3',
  megaphone: 'M3 11v2a1 1 0 0 0 1 1h3l6 4V6L7 10H4a1 1 0 0 0-1 1zM17 8a5 5 0 0 1 0 8M20 5a9 9 0 0 1 0 14',
  reload: 'M4 12a8 8 0 0 1 14-5.3L20 9M20 4v5h-5M20 12a8 8 0 0 1-14 5.3L4 15M4 20v-5h5',
  menu: 'M4 7h16M4 12h16M4 17h16',
  foldL: 'M4 5h16v14H4zM9 5v14M16 10l-2 2 2 2',
  foldR: 'M4 5h16v14H4zM9 5v14M13 10l2 2-2 2',
  desk: 'M4 5h16v11H4zM8 20h8M12 16v4',
  headset: 'M4 15v-3a8 8 0 0 1 16 0v3M4 15h3v5H5a1 1 0 0 1-1-1zM20 15h-3v5h2a1 1 0 0 0 1-1z',
  orders: 'M9 6h11M9 12h11M9 18h11M4 6h.01M4 12h.01M4 18h.01',
  sales: 'M12 3v18M17 7H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6',
  archive: 'M3 4h18v4H3zM5 8v12h14V8M10 12h4',
  clients: 'M8 11a4 4 0 1 0 0-8a4 4 0 0 0 0 8zM2 21a6 6 0 0 1 12 0M17 11a3 3 0 1 0 0-6M22 21a5 5 0 0 0-5-5',
  users: 'M12 11a4 4 0 1 0 0-8a4 4 0 0 0 0 8zM5 21a7 7 0 0 1 14 0M12 14l1.5 3L12 21l-1.5-4z',
  faq: 'M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0M9.6 9.4a2.5 2.5 0 1 1 3.4 2.4c-.6.3-1 .8-1 1.5v.4M12 16.8h.01',
  funnel: 'M3 4h18l-7 9v6l-4 2v-8z',
  load: 'M4 19V5M4 19h16M8 15l3-4 3 2 5-6',
  bars: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  star: 'M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9z',
  refuse: 'M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0M5.6 5.6l12.8 12.8',
  monitor: 'M3 12h4l3-8 4 16 3-8h4',
  old: 'M12 7v5l3 2M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0',
  swap: 'M4 8h13M13 4l4 4-4 4M20 16H7M11 12l-4 4 4 4',
  user: 'M7.5 8a4.5 4.5 0 1 0 9 0a4.5 4.5 0 1 0-9 0M4 20.5a8 8 0 0 1 16 0',
  out: 'M15 4h4v16h-4M10 8l-4 4 4 4M6 12h10',
  external: 'M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5',
  dot: 'M11 12a1 1 0 1 0 2 0a1 1 0 1 0-2 0',
} as const;

/** The icon of a page of the menu by its link (`main-menu.ts`); the old pages share one. */
const BY_LINK: Record<string, string> = {
  'call-center': SHELL_ICON.desk,
  'call-center-old': SHELL_ICON.headset,
  'my-sales': SHELL_ICON.sales,
  'orders': SHELL_ICON.orders,
  'orders-archive': SHELL_ICON.archive,
  'calls-new': SHELL_ICON.phone,
  'clients': SHELL_ICON.clients,
  'faq': SHELL_ICON.faq,
  'users': SHELL_ICON.users,
  'report/call-funnel': SHELL_ICON.funnel,
  'report/load': SHELL_ICON.load,
  'report/operator-summary': SHELL_ICON.bars,
  'feedbacks-new': SHELL_ICON.star,
  'rejections': SHELL_ICON.refuse,
  'report/monitoring': SHELL_ICON.monitor,
};

export function iconOfLink(link: string | undefined, old: boolean): string {
  if (old) {
    return SHELL_ICON.old;
  }
  return (link && BY_LINK[link]) || SHELL_ICON.dot;
}
